import { Steps, type StepsProps } from "antd";
import classNames from "classnames";
import styles from "./styles.module.scss";

export const AppSteps = ({ className, ...props }: StepsProps) => {
  return <Steps className={classNames(styles.steps, className)} {...props} />;
};
